import React from 'react';
import ProductGradeChip from './component/ProductGradeChip';

const minWidth = 150;

const RejectedColumns = [
  {
    field: 'segmentName',
    flex: 1,
    headerName: 'Segment',
    minWidth,
  },
  {
    field: 'shipperName',
    flex: 1,
    headerName: 'Shipper',
    minWidth,
  },
  {
    aggregable: false,
    field: 'productName',
    flex: 1,
    headerName: 'Product Grade',
    minWidth,
    renderCell: ({ value }) => <ProductGradeChip value={value} />,
  },
  {
    align: 'left',
    field: 'volNominated',
    flex: 1,
    headerAlign: 'left',
    headerName: 'Vol. Nominated (bbl)',
    minWidth,
    type: 'number',
  },
  {
    align: 'left',
    field: 'volAwarded',
    flex: 1,
    headerAlign: 'left',
    headerName: 'Vol. Awarded (bbl)',
    minWidth,
    type: 'number',
  },
  {
    aggregable: true,
    align: 'left',
    field: 'volAccepted',
    flex: 1,
    headerAlign: 'left',
    headerName: 'Vol. Accepted (bbl)',
    minWidth,
    type: 'number',
  },
  {
    field: 'nomMonth',
    flex: 1,
    headerName: 'Nomination Month',
    minWidth,
  },
];

export default RejectedColumns;
